import styled, { css } from 'styled-components'

export const CategoriesContainer = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 12px 10px;
  @media (min-width: 768px) {
    padding: 12px 40px;
  }
  background: #02e5ff;
  z-index: 1000;
  position: relative;
  width: ${props => props.w || '100%'};
  box-sizing: border-box;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .category {
    white-space: nowrap;
    cursor: pointer;
    user-select: none;
    transition: all 0.3s ease;
    margin-top: 10px;
    margin-bottom: 10px;
    &:nth-of-type(1) {
      margin-left: 0;
    }
  }

  div.special {
    ${props => !props.featured && css`
      display: none
    `}
  }

  @media (min-width: 769px) {
    ${({ isProfessional }) => isProfessional && css`
      width: 100%;
    `}
  }

  @media (min-width: 992px) {
    ${(props) => props.w && css`
      width: ${props.w};
    `}
  }
`
